var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 65 65",
    viewBox: "0 0 65 65",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m32.5 0c-17.9 0-32.5 14.6-32.5 32.5s14.6 32.5 32.5 32.5 32.5-14.6 32.5-32.5-14.6-32.5-32.5-32.5zm13.6 33.9-12.4 18.5c-.6.9-1.9.9-2.5 0l-12.3-18.5c-.7-1 0-2.4 1.2-2.4h6.7v-17.6c0-1.1.9-2 2-2h7.4c1.1 0 2 .9 2 2v17.6h6.7c1.1 0 1.8 1.4 1.2 2.4z",
    fill: "#424242",
    fillOpacity: 0.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/ARROW.fdd329f2f585a087df1abca975aed163.svg";
export { ForwardRef as ReactComponent };